import { graphql, compose } from "react-apollo"
import { connect } from "react-redux"
import { createMatchSelector, push } from "react-router-redux"
import gql from "graphql-tag"

import { NotFoundError } from "@swipesense/error-handling"

import routes from "../../routes"
import { addAssetFilter } from "../../store"
import UtilizationUnitDetailTableControlled from "./UtilizationUnitDetailTableControlled"

const query = gql`
  query AssetUtilizationDepartments($facilityId: ID!, $deviceTypeId: ID!) {
    facility(id: $facilityId) {
      id
      name
      managedByCurrentUser
      departments {
        id
        name
      }
      deviceType(id: $deviceTypeId) {
        name
      }
    }
  }
`

export default compose(
  connect(
    ({ router }) => {
      const matchResult = createMatchSelector(routes.utilizationDetail)({
        router,
      })
      if (!matchResult) {
        return null
      }
      return {
        facilityId: matchResult.params.facilityId,
        deviceTypeId: matchResult.params.deviceTypeId,
      }
    },
    dispatch => ({
      filterToExactDeviceType: deviceTypeId =>
        dispatch(addAssetFilter(deviceTypeId)),
      navigateToLocator: () => dispatch(push("../assets")),
    })
  ),
  graphql(query, {
    options: ({ facilityId, deviceTypeId }) => ({
      variables: { facilityId, deviceTypeId },
    }),
    props: ({ data: { loading, error, facility } }) => {
      if (loading) {
        return { loading }
      } else if (error) {
        throw error
      } else if (!facility) {
        throw new NotFoundError()
      } else {
        let defaultEntityId, defaultEntityType

        const departments = facility.departments
          .map(e => ({
            label: e.name,
            value: e.id,
          }))
          .sort((a, b) => (a.label > b.label ? 1 : -1))

        if (facility.managedByCurrentUser) {
          departments.unshift({
            label: "All Departments",
            value: null,
          })
          defaultEntityId = facility.id
          defaultEntityType = "facility"
        } else {
          defaultEntityId = departments[0].value
          defaultEntityType = "department"
        }

        return {
          deviceName: facility.deviceType.name,
          departments,
          defaultEntityId,
          defaultEntityType,
        }
      }
    },
  })
)(UtilizationUnitDetailTableControlled)
